import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { _breakP } from './utils.js';
export default class contentMenu {
  constructor() {
    if (_breakP.SP) {
      this.contentMenu();
    }
  }

  contentMenu() {
    const $menuBtn = document.querySelector('.js-contentMenu-button');
    const $contentMenu = document.querySelector('.js-contentMenu');

    if ($menuBtn) {
      $menuBtn.addEventListener('click', function () {
        if (this.classList.contains('is-active')) {
          $contentMenu.classList.remove('is-visible');
          clearAllBodyScrollLocks();
        } else {
          $contentMenu.classList.add('is-visible');
          disableBodyScroll($contentMenu);
        }
        this.classList.toggle('is-active');
      });
    }
  }
}
